export const PAGE_NAME = "admin-kyc-page";
